/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeadLink200ResponseResultData,
    DeadLink200ResponseResultDataFromJSON,
    DeadLink200ResponseResultDataFromJSONTyped,
    DeadLink200ResponseResultDataToJSON,
} from './DeadLink200ResponseResultData';

/**
 * dead_link_api の 200 レスポンス
 * @export
 * @interface DeadLink200Response
 */
export interface DeadLink200Response {
    /**
     * result が存在するかどうか
     * @type {boolean}
     * @memberof DeadLink200Response
     */
    result: boolean;
    /**
     * 
     * @type {DeadLink200ResponseResultData}
     * @memberof DeadLink200Response
     */
    resultData: DeadLink200ResponseResultData;
    /**
     * ステータスコードの文字列
     * @type {string}
     * @memberof DeadLink200Response
     */
    status: string;
}

export function DeadLink200ResponseFromJSON(json: any): DeadLink200Response {
    return DeadLink200ResponseFromJSONTyped(json, false);
}

export function DeadLink200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeadLink200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': json['result'],
        'resultData': DeadLink200ResponseResultDataFromJSON(json['result_data']),
        'status': json['status'],
    };
}

export function DeadLink200ResponseToJSON(value?: DeadLink200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
        'result_data': DeadLink200ResponseResultDataToJSON(value.resultData),
        'status': value.status,
    };
}

